import { useEffect } from 'react';

export const useClickOutside = (condition: boolean, close: () => void): void => {
  useEffect(() => {
    if (condition) {
      window.addEventListener('click', close);
    } else {
      window.removeEventListener('click', close);
    }

    return () => {
      window.removeEventListener('click', close);
    };
    // do not depend on close function. it may be a new function on every render
    // eslint-disable-next-line
  }, [condition]);
};
